import { toast } from '@ifixit/ui/lib/toast-queue';
import { safeSessionStorage } from '@ifixit/utils';

const STASH_KEY = 'successToastAfterReload';

export function reloadWithSuccessToast(title: string) {
   safeSessionStorage.setJson(STASH_KEY, { title });
   window.location.reload();
}

export function showStashedSuccessToast() {
   const stashed = safeSessionStorage.getJson<{ title: string }>(STASH_KEY);
   if (!stashed) {
      return;
   }
   safeSessionStorage.removeItem(STASH_KEY);
   toast.success(stashed.title);
}
